import React from 'react'
import Link from 'gatsby-link'
import createReactClass from 'create-react-class'

import Header from '../components/header'

const AboutPage = createReactClass({
  render() {
    return(
      <div style={{height:'100%', width: '100%'}}>
        <Header />
        <main className="t__about">
          <p> My name is Christopher Esartia. I am a full-stack developer located in New York.</p>

          <div className="m__about-block">
            <h2>Experience</h2>

            <aside>
              <h4>2016 - 2017:</h4>
              <p>Joined King & Partners as a Front-End developer. Lead front-end development for projects such as itsu.com and Tommie Copper. Introduced Atomic Design principles to codebase to help streamline front-end development. Also did back-end work using Rails and Node.js.</p>
            </aside>

            <aside>
              <h4>2015 - 2016:</h4>
              <p>Joined Moxie Media Group as a junior full-stack developer. Gained a lot of front-end experience on projects, ranging from template wire-framing and design, to implementing GSAP and animations with Angular.js. Learned a lot about back-end structures too, such as implementing JSON fields, handling cron jobs, writing automation scripts using Casper.js and Phantom.js</p>
            </aside>

            <aside>
              <h4>2014 - 2015:</h4>
              <p>Started a company called TwinNinja with a friend and built several prototype sites targeted for consumer spending and travel planning using Ember.js</p>
            </aside>

            <aside>
              <h4>2013 - 2014:</h4>
              <p>Intern at Tiger Party New York. Developed sites and applications using HTML, CSS, SASS, javaScript, jQuery and PHP</p>
            </aside>
          </div>

          <div className="m__about-block">
            <h2>Tools</h2>

            <aside>
              <h4>Frameworks</h4>
              <p> React, Redux, Flux, React-Native, Vue, Vuex </p>
            </aside>
            
            <aside>
              <h4>Language</h4>
              <p>JavaScript/ES7/ES6/ES5, HTML5, SASS/Stylus/CSS, Jade/Haml </p>
            </aside>

            <aside>
              <h4>Methodologies</h4>
              <p>Atomic Design, BEM, Modular components</p>
            </aside>

            <aside>
              <h4>Tools</h4>
              <p>Git, vim, Visual Studio, Adobe Suites, Flexbox, CSS Grids, Node.js</p>
            </aside>
          </div>

          <div className="m__about-block">
            <h2>Open-Source Projects</h2>

            <aside>
              <a href="https://github.com/Rulox/react-atomic-structure">React-Atomic-Structure:</a>
              <p>Package to help create new projects with Atomic Design principles setup up with React</p>
            </aside>

            <aside>
              <a href="https://github.com/Oliphaunte/vue-atomic-structure">Vue-Atomic-Structure:</a>
              <p>Package to help create new projects with Atomic Design principles setup up with Vue</p>
            </aside>
          </div>
        </main>
      </div>
    )
  }
})

export default AboutPage


// WEBPACK FOOTER //
// ./src/pages/about.js